export default {
  fields: {
    country: 'Țara băncii',
    iban: 'IBAN',
    routing_number: 'Cod de rutare',
    account_number: 'Număr de cont',
    sort_code: 'Cod bancar (sort code)',
    account_type: 'Tip de cont',
  },
  help: {
    country: 'Țara băncii, care poate diferi de cea a restaurantului.',
  },
  placeholders: {
    iban: 'DE89 3704 0044 0532 0130 00',
  },
  formats: {
    uk_local: {
      title: 'Sort code și număr de cont',
      description: 'Modul obișnuit de a introduce un cont din Marea Britanie.',
    },
    iban: {
      title: 'IBAN',
      description: 'Numărul internațional de cont bancar.',
    },
    us_local: {
      title: 'Număr de rutare și de cont',
      description: 'Un cont bancar din SUA.',
    },
  },
  account_types: {
    checking: 'Curent',
    savings: 'Economii',
  },
  actions: {
    save: 'Salvează contul bancar',
    cancel: 'Anulează',
    edit: 'Editează',
  },
  card: {
    account: 'Cont',
    country: 'Țară',
    status: 'Stare',
  },
  statuses: {
    active: 'Activ',
    pending_verification: 'În verificare',
    action_needed: 'Acțiune necesară',
    errored: 'Plata a eșuat',
    missing: 'Lipsă',
  },
  notes: {
    pending_verification:
      'Adyen verifică fiecare cont bancar înainte de începerea plăților. Confirmă-l pe pagina Adyen printr-o autentificare bancară sau un extras de cont.',
    action_needed: 'Furnizorul de plăți nu a putut confirma acest cont bancar. Verifică datele sau introdu alt cont.',
    errored: 'O plată către acest cont a eșuat, iar plățile sunt suspendate. Verifică datele sau introdu alt cont.',
  },
};
